module.exports = __webpack_public_path__ + "media/images/flags/4x3/tha-1366e19e7eae1ecc57d446cce69ba5ca.svg";